import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ContenedorService {

  private apiUrl = environment.apiURL_institucion;
  private headers = new HttpHeaders().append('Content-Type', 'application/json')
  .append('Authorization', 'Bearer ' + localStorage.getItem('token'));

  constructor(
    private cookies: CookieService,
    private http: HttpClient,
  ) { }

  public getAccess(correo: string): Observable<any>{
    const apiUrl = `${this.apiUrl}access/search?email=${correo}`;
    return this.http.get(`${apiUrl}`, {headers: this.headers});
  }
  public getInstitutions(): Observable<any>{
    const apiUrl = `${this.apiUrl}institucion`;
    return this.http.get(`${apiUrl}`, {headers: this.headers});
  }
  public getPlannings(): Observable<any>{
    const apiURL = `${this.apiUrl}planificacion`;
    return this.http.get(`${apiURL}`, {headers: this.headers});
  }
  public getPerspectives(): Observable<any>{
    const apiURL = `${this.apiUrl}perspectivas`;
    return this.http.get(`${apiURL}`, {headers: this.headers});
  }
  public getObjectives(): Observable<any>{
    const apiURL = `${this.apiUrl}objetivos`;
    return this.http.get(`${apiURL}`, {headers: this.headers});
  }
  public getIndicators(): Observable<any>{
    const apiURL = `${this.apiUrl}indicador`;
    return this.http.get(`${apiURL}`, {headers: this.headers});
  }
  public getProjects(): Observable<any>{
    const apiURL = `${this.apiUrl}proyectos`;
    return this.http.get(`${apiURL}`, {headers: this.headers});
  }

}
